import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';

import { DynamicFormComponent } from '@shared/dynamic-form/dynamic-form.component';

import { SortService } from '@services/sort.service';

@Component({
  selector: 'app-institution-edit-actus',
  templateUrl: './actus.component.html',
  styleUrls: ['./actus.component.scss']
})
export class ActusComponent extends DynamicFormComponent implements OnInit, OnDestroy {

  constructor(
    protected override sortService: SortService,
    protected override cdr: ChangeDetectorRef
  ) {
    super(sortService, cdr)
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.schema.forEach(schema => schema.childs?.forEach(child => {this.fieldVisible(child, child)}));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
